module.exports = __webpack_public_path__ + "static/step-2-8f42d4eef052bbfe8b00da294b1c7237.svg";